import { render, staticRenderFns } from "./editTeacherTraining.vue?vue&type=template&id=becfb0e8&scoped=true"
import script from "./editTeacherTraining.vue?vue&type=script&lang=js"
export * from "./editTeacherTraining.vue?vue&type=script&lang=js"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./editTeacherTraining.vue?vue&type=style&index=1&id=becfb0e8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "becfb0e8",
  null
  
)

export default component.exports